module.exports = __webpack_public_path__ + "img/sharp-example6.4b1cccf7.jpg";